<div>
  <ng-template #inputTemplate let-input>
    @for (input of input.inputs || []; track trackByChecksum($index, input)) {
      <ng-container *ngTemplateOutlet="inputTemplate; context: { $implicit: input }"></ng-container>
    }

    @if (!input.inputs) {
      <div margin-bottom-small-x>
        <rti-field-mapping-form-field
          (formFieldChanged)="handleFormFieldChange($event)"
          [integrationName]="integrationName"
          [integrationKind]="integrationKind"
          [formConfigId]="formConfig.id"
          [formInput]="input"
          [sources]="sources"
          [sourcesLoading]="sourcesLoading"
        ></rti-field-mapping-form-field>

        <rt-divider></rt-divider>
      </div>
    }
  </ng-template>

  @if (isDynamic()) {
    @if (isLoading) {
      <rt-placeloader variant="item"></rt-placeloader>
    }

    <rt-box layout-vertical variant="background-light no-padding" margin-tb>
      @if (!isLoading) {
        <div padding-tb-small-x padding-lr-small layout layout-align-items-center>
          <rt-icon name="label" margin-right-small-x></rt-icon>

          <rt-heading variant="subheading">
            {{ formConfig.remoteName }}

            @if (formConfig.inputsCount || formConfig.inputsCount === 0) {
              <rt-badge [text]="badgeLabel()" color="counter-default" margin-left-small-x>
              </rt-badge>
            }
          </rt-heading>

          <div margin-left-auto>
            @if (!isEditing) {
              <rt-icon-button
                (click)="startEditing()"
                variant="plain"
                iconName="edit"
                shape="square"
              >
              </rt-icon-button>
            }

            @if (isEditing) {
              <rt-icon-button
                (click)="stopEditing()"
                variant="plain"
                iconName="clear"
                shape="square"
              >
              </rt-icon-button>
            }
          </div>
        </div>
      }

      @if (!isLoading && isEditing) {
        <rt-divider variant="line"></rt-divider>

        @if (isLoading) {
          <rt-spinner variant="small"></rt-spinner>
        }

        @if (!isLoading && (formConfig.inputsCount || !!formConfig.errors)) {
          <div class="field-mapping-form-editable">
            @if (!!formConfig.errors) {
              <rti-error-messages-wrapper [errors]="formConfig.errors"></rti-error-messages-wrapper>
            }

            @for (input of formConfig.inputs; track trackByChecksum($index, input)) {
              <ng-container *ngTemplateOutlet="inputTemplate; context: { $implicit: input }">
              </ng-container>
            }
          </div>
        }

        @if (formConfig.inputsCount === 0) {
          <rt-infobox
            [isDismissible]="false"
            [iconName]="'info-outline'"
            type="transparent"
            padding-medium
            >{{
              'rti.field_mapping.settings.remote_template.no_mappable_fields' | translate
            }}</rt-infobox
          >
        }

        <rt-divider variant="line"></rt-divider>

        <div layout-horizontal layout-space-between padding class="field-mapping-form-editable">
          <div>
            <rt-button
              (click)="delete(); $event.stopPropagation()"
              variant="plain"
              class="danger-on-hover"
            >
              <rt-icon name="remove-circle"></rt-icon>
              <span>{{ 'rti.field_mapping.settings.remove_template' | translate }}</span>
            </rt-button>
          </div>
        </div>
      }
    </rt-box>
  }

  @if (!isDynamic()) {
    @if (isLoading) {
      <rt-spinner variant="small"></rt-spinner>
    }

    @if (!isLoading) {
      @if (!!formConfig.errors) {
        <rti-error-messages-wrapper [errors]="formConfig.errors"></rti-error-messages-wrapper>
      }

      @for (input of formConfig.inputs || []; track trackByChecksum($index, input)) {
        <ng-container
          *ngTemplateOutlet="inputTemplate; context: { $implicit: input }"
        ></ng-container>
      }
    }
  }
</div>
